import request from '@/utils/request'

/**
 * 查询店铺VIP用户账户列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopVipAccount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/account.queryShopVipAccount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}